export default __webpack_public_path__ + "static/media/champagne.6f751fba.jpg";